import * as React from 'react';
import clx from 'classnames';
import './RequestStateTag.scss';
import { Tag } from 'antd';
import { RequestState } from 'common/schema/request/Request';
import { useTranslation } from 'react-i18next';
import { assertNever } from 'server/utils/typings/assertNever';

export interface RequestStateTagProps {
  status: RequestState;
}

export function RequestStateTag(props: RequestStateTagProps) {
  const { t } = useTranslation();

  const status = () => {
    switch (props.status) {
      case RequestState.Draft:
        return t('procedures.my.list.state-draft', 'Bozza');
      case RequestState.Sent:
        return t('procedures.my.list.state-sent', 'Inviata');
      case RequestState.Sending:
        return t('procedures.my.list.state-sending', 'In Invio');
      case RequestState.NeedRetry:
        return t('procedures.my.list.state-need-retry', 'In Carico');
      case RequestState.Failed:
        return t('procedures.my.list.state-failed', 'Fallita');
      case RequestState.Cancelled:
        return t('procedures.my.list.state-cancelled', 'Annullata');
      case RequestState.Tested:
        return t('procedures.my.list.state-sent-as-test', 'Inviata in Test');
      default:
        assertNever(props.status);
    }
  };
  return (
    <Tag className={clx('request-status-tag', props.status.toLowerCase())}>
      {status()}
    </Tag>
  );
}
